import React from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

import { DIE_TYPES, FACES } from '../../constants'
import IconButton from '../../components/IconButton'

export const rnd = (max) => {
  const random = Math.random() * max
  const result = Math.floor(random) + 1
  console.log(`[Roll] 0 - ${max}, Math.random * max: ${random}; result: ${result};`);
  return result
}

export const getDieRoll = (diceType, num) => {
  let side

  switch (diceType) {
    case DIE_TYPES.ability:
    case DIE_TYPES.difficulty: {
      side = rnd(8)
      break
    }

    case DIE_TYPES.proficiency:
    case DIE_TYPES.challenge:
    case DIE_TYPES.destiny: {
      side = rnd(12)
      break
    }

    case DIE_TYPES.boost:
    case DIE_TYPES.setback: {
      side = rnd(6)
      break
    }

    case 'd100': {
      side = rnd(num)
      break
    }

    default:
      return false
  }

  return side
}

/*
  roll: {
    ability: [ 0, 2, 1 ]
    etc.
  }
*/
export const computeResult = (roll) => {
  const rollString = Object.keys(roll).map((diceType) => {
    const rollResults = roll[diceType]
    return rollResults.map((dieFace) => {
      if (diceType === 'd100') return ''
      return FACES[diceType][dieFace].face
    }).join('')
  }).join('')

  // triumph = r, threat = t
  const r = (rollString.match(/r/g) || []).length
  const s = (rollString.match(/s/g) || []).length
  const a = (rollString.match(/a/g) || []).length
  const f = (rollString.match(/f/g) || []).length
  const t = (rollString.match(/t/g) || []).length
  const d = (rollString.match(/d/g) || []).length

  // Destiny, n = dark, l = light
  const n = (rollString.match(/n/g) || []).length
  const l = (rollString.match(/l/g) || []).length

  return { r, s, a, d, f, t, n, l }
}

const ExpandComponent = ({ isOpen, onClick }) => {
  return (
    <IconButton
      css={`
        font-size: 28px;
        margin: -2px 6px 0 -8px;
      `}
      onClick={onClick}
    >
      {isOpen ?
        <ExpandMoreIcon fontSize='inherit' />
        :
        <ExpandLessIcon fontSize='inherit' />
      }
    </IconButton>
  )
}

export const usePaperExpand = (keyName, disabled = false) => {
  const [ isOpen, setIsOpen ] = React.useState(true)

  React.useEffect(() => {
    if (!disabled) setIsOpen(window.localStorage.getItem(`swroller-paper-${keyName}`) !== 'false')
  }, [ keyName, disabled ])

  const toggle = React.useCallback(() => {
    setIsOpen(!isOpen)
    window.localStorage.setItem(`swroller-paper-${keyName}`, !isOpen)
  }, [ keyName, isOpen, setIsOpen ])

  const component = React.useMemo(
    () => disabled ? false : <ExpandComponent isOpen={isOpen} onClick={toggle} />,
    [ disabled, isOpen, toggle ]
  )

  return { isOpen, toggleOpen: toggle, expander: component }
}
